









import { Component } from 'vue-property-decorator';
import SingleActivityBox from './SingleActivityBox';
import SubscribeButton from '@/modules/calendar/components/locations/SubscribeButton.vue';
import { Getter } from 'vuex-class';
import { Environment } from '@/modules/configuration/store/types';

@Component({
    name: 'BoxFooter',
    components: {
        SubscribeButton,
    },
})
export default class BoxFooter extends SingleActivityBox {
    @Getter('environment', { namespace: 'configuration' }) private environment!: Environment;
    protected aspectRatio = 1;

    private get zoukWrocloveMobileView() {
        return this.environment.name === 'zoukwroclove';
    }
}
